import React, { ComponentProps } from 'react';
import styled, { keyframes } from 'styled-components';
import { Box } from '../layout/Box';

const rotate = keyframes`
    0% { transform: rotate(0deg); }
    100% { transform: rotate(360deg); }
`;

const stroke = keyframes`
    0% {
        stroke-dasharray: 1px, 200px;
        stroke-dashoffset: 0;
    }

    50% {
        stroke-dasharray: 100px, 200px;
        stroke-dashoffset: -15px;
    }

    100% {
        stroke-dasharray: 100px, 200px;
        stroke-dashoffset: -125px;
    }
`;

const Root = styled(Box)`
    display: inline-block;
    animation: 1.4s linear 0s infinite normal none running ${rotate};
`;

const Circle = styled.circle`
    stroke: var(--color-primary);
    stroke-dasharray: 80px, 200px;
    stroke-dashoffset: 0;
    animation: 1.4s ease-in-out 0s infinite normal none running ${stroke};
`;

interface CircularProgressProps extends ComponentProps<typeof Box> {
    size?: number;
}

export const CircularProgress = (props: CircularProgressProps) => {
    const { size = 24, color, ...other } = props;

    return (
        <Root {...other} role="progressbar" style={{ width: size, height: size }}>
            <svg viewBox="22 22 44 44">
                <Circle
                    cx="44"
                    cy="44"
                    r="20.2"
                    fill="none"
                    strokeWidth="3.6"
                    style={{ stroke: color }}
                />
            </svg>
        </Root>
    );
};
